import { useMutation } from '@tanstack/react-query';
import {
  generateDraftStepSummaryContract,
  type GenerateDraftStepSummaryResponse
} from '@bliks-io/contracts';
import { apiClient } from '../client';

interface GenerateDraftStepSummaryVariables {
  processId: string;
  stepId: string;
}

/**
 * Calls the AI generate-summary endpoint for a draft step.
 * Does not persist — caller decides whether to apply the returned name and description.
 */
export function useGenerateDraftStepSummary() {
  return useMutation({
    mutationFn: async ({
      processId,
      stepId
    }: GenerateDraftStepSummaryVariables): Promise<GenerateDraftStepSummaryResponse> => {
      const path = generateDraftStepSummaryContract.path
        .replace(':processId', processId)
        .replace(':stepId', stepId);
      const { data } = await apiClient.post<GenerateDraftStepSummaryResponse>(path, {});
      return data;
    }
  });
}
